import { Icon } from '@chakra-ui/react';

export const EmojiQuestion = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M9.99333 3.3335C6.31333 3.3335 3.33333 6.3135 3.33333 10.0002C3.33333 13.6868 6.31333 16.6668 9.99333 16.6668C13.6733 16.6668 16.6667 13.6868 16.6667 10.0002C16.6667 6.3135 13.68 3.3335 9.99333 3.3335ZM10 15.3335C7.05333 15.3335 4.66667 12.9468 4.66667 10.0002C4.66667 7.0535 7.05333 4.66683 10 4.66683C12.9467 4.66683 15.3333 7.0535 15.3333 10.0002C15.3333 12.9468 12.9467 15.3335 10 15.3335ZM10.6667 8.62683L11.3733 9.3335L12.08 8.62683L12.7867 9.3335L13.4933 8.62683L12.08 7.2135L10.6667 8.62683ZM7.92 8.62683L8.62666 9.3335L9.33333 8.62683L7.92 7.2135L6.50667 8.62683L7.21333 9.3335L7.92 8.62683ZM10 13.6668C11.5533 13.6668 12.8733 12.6935 13.4067 11.3335H6.59333C7.12667 12.6935 8.44667 13.6668 10 13.6668Z"
      fill="currentColor"
    />
  </Icon>
);
